module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('legend', [_vm._v("Campos")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btn-add-field",
      "to": {
        name: 'FormFieldDetail',
        params: {
          reqType: _vm.reqType,
          section: _vm.sectionId,
          id: null
        }
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Campo\n  ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.updating) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.fields.length == 0) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "msg-no-fields"
    }
  }, [_vm._v("\n            Formulário ainda não possui campos de preenchimento.\n    ")]) : _c('draggable', {
    staticClass: "list-group",
    on: {
      "end": _vm.checkMove
    },
    model: {
      value: (_vm.fields),
      callback: function($$v) {
        _vm.fields = $$v
      },
      expression: "fields"
    }
  }, _vm._l((_vm.fields), function(f) {
    return _c('div', {
      staticClass: "list-group-item"
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [(f.type == 'text' || f.type == 'cpf' || f.type == 'cnpj') ? _c('span', {
      staticClass: "glyphicon glyphicon-text-size"
    }) : _vm._e(), _vm._v(" "), (f.type == 'number') ? _c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }) : _vm._e(), _vm._v(" "), (f.type == 'date') ? _c('span', {
      staticClass: "glyphicon glyphicon-calendar"
    }) : _vm._e(), _vm._v(" "), (f.type == 'document') ? _c('span', {
      staticClass: "glyphicon glyphicon-picture"
    }) : _vm._e(), _vm._v(" "), (f.type == 'file') ? _c('span', {
      staticClass: "glyphicon glyphicon-file"
    }) : _vm._e(), _vm._v(" "), (f.type == 'select') ? _c('span', {
      staticClass: "glyphicon glyphicon-list"
    }) : _vm._e(), _vm._v(" "), (f.type == 'link') ? _c('span', {
      staticClass: "glyphicon glyphicon-link"
    }) : _vm._e(), _vm._v(" "), (f.type == 'textarea') ? _c('span', {
      staticClass: "glyphicon glyphicon-font"
    }) : _vm._e(), _vm._v(" "), (f.type == 'separator') ? _c('span', {
      staticClass: "glyphicon glyphicon-text-color"
    }) : _vm._e(), _vm._v(" "), (f.type == 'checkbox') ? _c('span', {
      staticClass: "glyphicon glyphicon-check"
    }) : _vm._e(), _vm._v(" "), (f.type == 'phone') ? _c('span', {
      staticClass: "glyphicon glyphicon-phone"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(f.name) + "\n            "), (f.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("(Obrigatório)")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.counts[f.objectId] > 0),
        expression: "counts[f.objectId] > 0"
      }],
      staticClass: "badge"
    }, [_vm._v(_vm._s(_vm.counts[f.objectId]) + " redirecionamento(s)")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "to": {
          name: 'FormFieldDetail',
          params: {
            reqType: _vm.reqType,
            section: _vm.sectionId,
            id: f.objectId
          }
        },
        "type": "button",
        "title": "Editar campo"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-edit"
    }), _vm._v(" Editar\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "title": "Remover campo"
      },
      on: {
        "click": function($event) {
          return _vm.remove(f)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove"
    }), _vm._v(" Remover\n              ")])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(f.description))])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1abbee2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormFieldList.vue
// module id = 1475
// module chunks = 1